import axios from 'axios'
import { passThroughAxios } from './passThrough.axios'
import FileUploadApi from './FileUpload.api.js'

export default {
  async getBulkChangeOrders(page, includeNationWide, search) {
    const params = {
      page,
      includeNationWide,
      size: 15,
      search,
    }
    try {
      const response = await passThroughAxios.get('bulkChangeOrders', { params })
      return Promise.resolve(response.data.Results || [])
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async getBulkChangeOrderByBulkChangeOrderId(bulkChangeOrderId) {
    try {
      const response = await passThroughAxios.get(`bulkChangeOrder/${bulkChangeOrderId}`)
      return Promise.resolve(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async uploadBulkChangeOrder(file) {
    try {
      const { token } = await FileUploadApi.uploadToStaging(file)
      const response = await passThroughAxios.post('uploadBulkChangeOrder', null, {
        params: { fileToken: token },
      })
      return Promise.resolve(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async processBulkChangeOrder(bulkChangeOrderId, bulkChangeOrderAction) {
    try {
      await passThroughAxios.post(`bulkChangeOrder/${bulkChangeOrderId}/process`, null, {
        params: { action: bulkChangeOrderAction },
      })
      return Promise.resolve()
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async deleteBulkChangeOrder(bulkChangeOrderId) {
    try {
      return await passThroughAxios.delete(`bulkChangeOrder/${bulkChangeOrderId}`)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async pauseBulkChangeOrder(bulkChangeOrderId) {
    try {
      return await passThroughAxios.post(`bulkChangeOrder/${bulkChangeOrderId}/pause`)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async resumeBulkChangeOrder(bulkChangeOrderId) {
    try {
      return await passThroughAxios.post(`bulkChangeOrder/${bulkChangeOrderId}/resume`)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async downloadExcelExport(bulkChangeOrderId) {
    try {
      const response = await axios.get(`GetBulkChangeOrder/${bulkChangeOrderId}/ExcelResult`, {
        responseType: 'blob',
      })
      let fileName = response.headers['content-disposition'].split('filename=')[1].split(';')[0]
      saveAs(response.data, fileName)
    } catch (e) {
      return Promise.reject(e)
    }
  },
}
